<template>
  <FilterDropdown :model-value="dropdownValue" :options="dropdownOptions" placeholder="size" show-all
    @update:model-value="$emit('update:size', $event)">
    <template #footer>
      <SizeRangeInputs :model-value="sizeRange" :unit="unit" @update:model-value="$emit('update:size-range', $event)" />
    </template>
  </FilterDropdown>
</template>

<script>
import FilterDropdown from '@/components/gallery/FilterDropdown.vue'
import SizeRangeInputs from '@/components/gallery/SizeRangeInputs.vue'
import { hasSizeRange } from '@/utils/sizeUnits'

// Size brackets plus the custom from/to boxes, shared by the desktop and mobile filter bars
export default {
  name: 'SizeFilterDropdown',
  components: { FilterDropdown, SizeRangeInputs },

  props: {
    size: { type: String, default: '' },
    // [{ value, text, range }]
    options: { type: Array, default: () => [] },
    sizeRange: { type: Object, required: true },
    unit: { type: String, default: 'cm' }
  },

  emits: ['update:size', 'update:size-range'],

  computed: {
    // A custom size shows as "custom" on the closed dropdown
    dropdownValue() {
      return this.size || (hasSizeRange(this.sizeRange) ? 'custom' : '')
    },
    // Name on the trigger, range as a second line in the list
    dropdownOptions() {
      return this.options.map(o => ({ value: o.value, text: o.text, hint: o.range }))
    }
  }
}
</script>
